// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609301810/js/" + chunkId + "." + {"44":"a447c65f","225":"15441d1a","481":"952ac0d1","486":"8cca86c9","770":"8aa2b28f"}[chunkId] + ".0.6553425420123293.chunk.js";
};